import { LANGUAGE_ROSTER_FROM_ES } from './languageRoster.js';

export const SUPPORTED_LANGUAGES = [...LANGUAGE_ROSTER_FROM_ES];

export const DEFAULT_LANGUAGE = 'es';

export const SUPPORTED_LANGUAGE_SET = new Set(SUPPORTED_LANGUAGES);

export const SUPPORTED_LANGUAGE_DEFINITIONS = {
  es: { name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', countryCode: 'es', selectorLabel: 'Spanish (Español)' },
  en: { name: 'English', nativeName: 'English', flag: '🇺🇸', countryCode: 'us', selectorLabel: 'English (English)' },
  pt: { name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷', countryCode: 'br', selectorLabel: 'Portuguese (Português)' },
  fr: { name: 'French', nativeName: 'Français', flag: '🇫🇷', countryCode: 'fr', selectorLabel: 'French (Français)' },
  it: { name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', countryCode: 'it', selectorLabel: 'Italian (Italiano)' },
  de: { name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', countryCode: 'de', selectorLabel: 'German (Deutsch)' },
  nl: { name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱', countryCode: 'nl', selectorLabel: 'Dutch (Nederlands)' },
  pl: { name: 'Polish', nativeName: 'Polski', flag: '🇵🇱', countryCode: 'pl', selectorLabel: 'Polish (Polski)' },
  ru: { name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', countryCode: 'ru', selectorLabel: 'Russian (Русский)' },
  sv: { name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪', countryCode: 'se', selectorLabel: 'Swedish (Svenska)' },
  el: { name: 'Greek', nativeName: 'Ελληνικά', flag: '🇬🇷', countryCode: 'gr', selectorLabel: 'Greek (Ελληνικά)' },
  tr: { name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷', countryCode: 'tr', selectorLabel: 'Turkish (Türkçe)' },
  ar: { name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', countryCode: 'sa', selectorLabel: 'Arabic (العربية)' },
  he: { name: 'Hebrew', nativeName: 'עברית', flag: '🇮🇱', countryCode: 'il', selectorLabel: 'Hebrew (עברית)' },
  hi: { name: 'Hindi', nativeName: 'हिंदी', flag: '🇮🇳', countryCode: 'in', selectorLabel: 'Hindi (हिंदी)' },
  ja: { name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', countryCode: 'jp', selectorLabel: 'Japanese (日本語)' },
  ko: { name: 'Korean', nativeName: '한국어', flag: '🇰🇷', countryCode: 'kr', selectorLabel: 'Korean (한국어)' },
  zh: { name: 'Chinese', nativeName: '中文', flag: '🇨🇳', countryCode: 'cn', selectorLabel: 'Chinese (中文)' },
};
